import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Transition from '../utils/Transition.js';
import Dropdown from '../utils/Dropdown';
import { useSession } from '../utils/Session.js';
import { features } from '../data/features.js';

function Header() {
  const session = useSession()
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [top, setTop] = useState(true);

  const mobileNav = useRef(null);

  // close the mobile menu on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!mobileNavOpen || mobileNav.current.contains(target)) return;
      setMobileNavOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close the mobile menu if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!mobileNavOpen || keyCode !== 27) return;
      setMobileNavOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  // detect whether user has scrolled the page down by 10px 
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);

  const links = [
    { text: 'Home', to: '/' },
    //{ text: 'Pricing', to: '/pricing' },
    // { text: 'About Us', to: '/about' },
    { text: 'Tools', sub: features.map(e => { return { to: e.link, text: e.main } }) }
  ]

  const signInButton = !session.switchLoginState?.[0] ? <button className="btn-sm bg-gray-900 ml-3 w-32 h-10 animate-pulse"></button> :
    <button className={session.user ? "btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3 w-32 h-10" : "btn p-0 flex m-auto"} onClick={() => session.switchLoginState[0]()}>
      {session.user ? <span>Sign out</span> : <img className="md:max-w-none mx-auto rounded" src={require('../images/btn_google_signin_light_normal_web.png')} alt="Google Sign In" />}
    </button>

  /*
    const signInButton = session.switchLoginState?.[0] ? <button className="btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3 w-32 h-10" onClick={() => session.switchLoginState[0]()}>
      {!session.user && <img className="h-4 mr-3" src="data:image/png;base64,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" alt=""></img>}
      <span>Sign {session.user ? 'out' : 'in'}</span>
    </button> : <button className="btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3 w-32 h-10 animate-pulse"></button>
  */
  return (
    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-white blur shadow-lg'}`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Site branding */}
          <div className="flex-shrink-0 mr-4">
            {/* Logo */}
            <Link to="/" className="block" aria-label="Cruip">
              <img src={require('../images/logo.svg')} alt='logo' width='45' height='45' />
            </Link>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden md:flex md:flex-grow">

            {/* Desktop menu links */}
            <ul className="flex flex-grow justify-end flex-wrap items-center">
              {links.map(link => {
                if (link.sub) return <Dropdown key={link.text} title={link.text}>{link.sub.map(link => <li key={link.text}><Link to={link.to} className="font-medium text-sm text-gray-600 hover:text-gray-900 flex py-2 px-5 leading-tight">{link.text}</Link></li>)}</Dropdown>
                else return <li key={link.text}><Link to={link.to} className="text-gray-600 hover:text-gray-900 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out">{link.text}</Link></li>
              })}
            </ul>

            {/* Desktop sign in links */}
            <ul className="flex justify-end flex-wrap items-center">
              <li>
                {signInButton}
              </li>
            </ul>

          </nav>

          {/* Mobile menu */}
          <div className="flex md:hidden">

            {/* Hamburger button */}
            <button
              className={`hamburger ${mobileNavOpen && 'active'}`}
              aria-controls="mobile-nav"
              aria-expanded={mobileNavOpen}
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
            >
              <span className="sr-only">Menu</span>
              <svg className="w-6 h-6 fill-current text-gray-900" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect y="4" width="24" height="2" />
                <rect y="11" width="24" height="2" />
                <rect y="18" width="24" height="2" />
              </svg>
            </button>

            {/*Mobile navigation */}
            <div ref={mobileNav}>
              <Transition
                show={mobileNavOpen}
                tag="nav"
                id="mobile-nav"
                className="absolute top-full h-screen pb-16 z-20 left-0 w-full overflow-scroll bg-white transition-all duration-300 ease-in-out"
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
              >
                <ul className="px-5 py-2">
                  {links.map(link => {
                    if (link.sub) return <li key={link.text} className="py-2 my-2 border-t border-b border-gray-200">
                      <span className="flex text-gray-600 hover:text-gray-900 py-2">{link.text}</span>
                      <ul className="pl-4">
                        {link.sub.map(link => <li key={link.text}><Link to={link.to} className="text-sm flex font-medium text-gray-600 hover:text-gray-900 py-2">{link.text}</Link></li>)}
                      </ul>
                    </li>
                    else return <li key={link.text}><Link to={link.to} className="flex text-gray-600 hover:text-gray-900 py-2">{link.text}</Link></li>
                  })}

                  <li>
                    {signInButton}
                  </li>
                </ul>
              </Transition>
            </div>

          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
